import React from 'react'
import TokenIcon from './TokenIcon'
import { normalizePixe } from './utils'

type Asset = { symbol: string; name: string; balance: string | number; fiat_value: string | number }

export default function AssetsList({ assets, onSendPixe }: { assets: Asset[]; onSendPixe?: () => void }) {
  if (!assets || assets.length === 0) {
    return <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">No assets yet.</div>
  }
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="text-white/60">
          <tr className="border-b border-white/10">
            <th className="text-left font-semibold px-4 py-2">Asset</th>
            <th className="text-right font-semibold px-4 py-2">Balance</th>
            <th className="text-right font-semibold px-4 py-2">Value</th>
            <th className="px-2 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {assets.map((a) => (
            <tr key={a.symbol} className="border-t border-white/10">
              <td className="px-4 py-2 text-white">
                <div className="flex items-center gap-3 min-w-0">
                  <TokenIcon symbol={a.symbol} />
                  <div className="min-w-0">
                    <div className="font-semibold truncate">{a.name}</div>
                    <div className="text-xs text-white/60">{a.symbol}</div>
                  </div>
                </div>
              </td>
              <td className="px-4 py-2 text-right text-white/90">{fmtAmount(a.balance)}</td>
              <td className="px-4 py-2 text-right text-white">{fmtUSD(a.fiat_value)}</td>
              <td className="px-2 py-2 text-right">
                {a.symbol === 'PIXE' && (
                  <button onClick={onSendPixe} className="px-2.5 py-1.5 rounded-md border border-white/15 text-white/90 hover:bg-white/10">Send</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function fmtAmount(n: string | number) {
  const v = typeof n === 'string' ? Number(n) : n
  if (!Number.isFinite(v as number)) return String(n)
  const nv = normalizePixe(v as number)
  return nv.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function fmtUSD(n: string | number) {
  const v = typeof n === 'string' ? Number(n) : n
  if (!Number.isFinite(v as number)) return String(n)
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(v as number)
}

